import { FC } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from './card'
import { Button } from './button'
import { Sparkles, ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

type UpgradePromptProps = {
  feature: string
  description: string
  requiredTier: 'Premium' | 'Enterprise'
  compact?: boolean
}

export const UpgradePrompt: FC<UpgradePromptProps> = ({
  feature,
  description,
  requiredTier,
  compact = false
}) => {
  const navigate = useNavigate()

  if (compact) {
    return (
      <div className="bg-gradient-to-r from-sumoPrimary/10 to-sumoAmber/10 dark:from-sumoPrimary/5 dark:to-sumoAmber/5 border border-sumoPrimary/30 dark:border-sumoPrimary/20 rounded-lg p-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="bg-sumoPrimary/20 dark:bg-sumoPrimary/10 p-2 rounded-full">
              <Sparkles className="text-sumoPrimary" width={20} height={20} />
            </div>
            <div>
              <p className="font-semibold text-neutral900 dark:text-neutral100 text-sm">
                {feature}
              </p>
              <p className="text-xs text-neutral600 dark:text-neutral400">
                Upgrade to {requiredTier} to unlock
              </p>
            </div>
          </div>
          <Button
            variant="primary"
            size="sm"
            onClick={() => navigate('/settings')}
            className="flex-shrink-0"
          >
            Upgrade
          </Button>
        </div>
      </div>
    )
  }

  return (
    <Card className="border-2 border-sumoPrimary/30 dark:border-sumoPrimary/20 bg-gradient-to-br from-sumoCream/50 to-transparent dark:from-sumoPrimary/5 dark:to-transparent">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-xl">
          <div className="bg-gradient-to-br from-sumoPrimary to-sumoAmber p-2 rounded-lg">
            <Sparkles className="text-sumoNavy" width={24} height={24} />
          </div>
          <span className="dark:text-neutral100">{feature}</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-neutral600 dark:text-neutral400">
          {description}
        </p>
        <div className="bg-sumoPrimary/10 dark:bg-sumoPrimary/5 border border-sumoPrimary/20 rounded-lg p-3">
          <p className="text-sm font-semibold text-neutral900 dark:text-neutral100 mb-1">
            Available in {requiredTier}
          </p>
          <p className="text-xs text-neutral600 dark:text-neutral400">
            Unlock this feature and more by upgrading your subscription
          </p>
        </div>
        <Button
          variant="primary"
          onClick={() => navigate('/settings')}
          className="w-full flex items-center justify-center gap-2"
        >
          Upgrade to {requiredTier}
          <ArrowRight width={16} height={16} />
        </Button>
      </CardContent>
    </Card>
  )
}
